import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserLoginServiceProxy, UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { DropdownPopComponent } from '../dropdown-pop/dropdown-pop.component';

@Component({
  selector: 'app-downloadfile',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent implements OnInit  {
    @ViewChild('appdownloadpopModels', { static: true }) appdownloadpopModels: DropdownPopComponent;
    @ViewChild('downloadItpApps', { static: true }) downloadItpModal: ModalDirective;
    @Input() iconOnly = false;
    @Input() isDropup = false;
    @Input() togglerCssClass = 'btn btn-icon w-auto btn-clean d-flex align-items-center btn-md px-2';
    @Input() textCssClass = 'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3';
    @Input() symbolCssClass = 'symbol symbol-35 symbol-light-success';
    @Input() symbolTextCssClass = 'symbol-label font-size-h5 font-weight-bold';
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1';
    active = false;
    saving = false;
    showModal: boolean;
    isLoginForFirstTime: boolean = false;
    checkLogin: string;
    carddata = [{ id: '1', name: 'Copilot For Windows', img: '../../../assets/common/images/login/NewWindowsDownloadIcon.png', imgIcon: '../../../assets/common/images/login/microsoft_logo.svg' },
        { id: '2', name: 'Copilot For MAC', img: '../../../assets/common/images/login/NewMacDownloadIcon.png', imgIcon: '../../../assets/common/images/login/mac.svg' },
        { id: '3', name: 'Copilot For Linux ', img: '../../../assets/common/images/login/NewLinuxDownloadIcon.png', imgIcon: '../../../assets/common/images/login/android.svg' },
    //{ id: '4', name: 'IOS App', img: '../../../assets/common/images/login/Characters-04.svg', imgIcon: '../../../assets/common/images/login/IOS.svg' }
    ];

    URIDownload: string;

    constructor(private userServiceProxy: UserServiceProxy, private _userLoginAppService: UserLoginServiceProxy) { }

    ngOnInit(): void {
        let thisObj = this;
        // this.downloadItpModal.show();
        //this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess')) == undefined || JSON.parse(localStorage.getItem('checkLoginSuccess')) === true ? false : true;
        abp.event.on("DownloadITPModalShow", () => this.downloadITPModalShow());
        abp.event.on('checkLoginForTopbardownload', function () { thisObj.userQuickStartDetailsCheck(); });
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }
   
    checkEvent(e:any) {
     
            localStorage.setItem('FirstTimeCheck', 'true');
            abp.event.trigger('CheckFirstLoginofUser');

    }

    userQuickStartDetailsCheck() {
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    downloadAgentAppWindows(item) {
        
        if (item.id === '1') {
            //this.userServiceProxy.downloadAgentAppWindows().subscribe(r => console.log(r));
            window.open("https://intimeproprodstorage.blob.core.windows.net/electron/DownloadMico/intimepro.exe", '_self');
        } else if (item.id === '2') {
            //window.open("https://intimeprosstorage.blob.core.windows.net/itpmacagentappuat/in%20time%20pro%20setup.pkg", '_self');
            window.open("https://intimeproprodstorage.blob.core.windows.net/electron/DownloadMico/intimepro.zip", '_self');
        } else if (item.id === '3') {
            window.open("https://intimeprosstorage.file.core.windows.net/itpmacapppackage/ITP_Mac.pkg?st=2021-11-25T10:00:02Z&se=2023-01-01T10:00:00Z&sp=rcwdl&sv=2018-03-28&sr=f&sig=hDWxnhxWj%2fJlS989Lj8FnnYX6B6ay5YQyGSQYUMDDX4%3D", '_self');
        } else if (item.id === '4') {
            window.open("https://intimeprosstorage.file.core.windows.net/itpmacapppackage/ITP_Mac.pkg?st=2021-11-25T10:00:02Z&se=2023-01-01T10:00:00Z&sp=rcwdl&sv=2018-03-28&sr=f&sig=hDWxnhxWj%2fJlS989Lj8FnnYX6B6ay5YQyGSQYUMDDX4%3D", '_self');
        }
    }
    downloadITPModalShow() {
        this.downloadItpModal.show();
    }
    remindMeLater(flag) {
        this.userServiceProxy.setRemindMeLaterForAgentApp(flag).subscribe(r => {});
        localStorage.setItem('firstTimeLoggedIn', 'false');
       
    }
}
